import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer, Slide } from 'react-toastify';
import { Provider, useSelector } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import store, { persistor } from './store';
import Routing from './routes';
import GlobalStyles from './styles/GlobalStyles';
import Menu from './components/Menu';
import { ModuleProvider } from './components/Menu/ModuleContext';

import AppShell from './components/AppShell';
import ErrorBoundary from './components/ErrorBoundary';
import httpClient from './services/axios';
import installContractInterceptor from './errors/installContractInterceptor';

// ---------------------------------------------------------------------------
// FC1 §A.3 — instalação do interceptor de contrato.
//
// Chamada explícita, no corpo do módulo, DEPOIS dos imports: todo import acima
// (inclusive `./store`, que puxa o saga de auth e registra o interceptor de
// refresh/401/403) já terminou de avaliar quando esta linha roda. Interceptors
// de resposta rodam na ordem de registro, então o de auth vê o erro CRU e este
// é a última transformação antes do `catch` da aplicação.
//
// Não trocar por `import './errors/installContractInterceptor'`: a ordem
// passaria a depender da posição da linha de import.
// ---------------------------------------------------------------------------
installContractInterceptor(httpClient);

function AppContent() {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  return (
    <>
      <GlobalStyles />

      {isLoggedIn ? (
        <AppShell sidebar={<Menu />} title="MyShop">
          <Routing />
        </AppShell>
      ) : (
        <Routing />
      )}
    </>
  );
}

// ---------------------------------------------------------------------------
// ToastContainer declarado aqui — irmão direto do BrowserRouter, fora de
// qualquer wrapper que crie stacking context (AppShell, modais, etc.).
// z-index 99999 garante sobreposição sobre qualquer modal do sistema.
// ---------------------------------------------------------------------------
function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        {/* FC4 §B.6 — boundary global. Fica DENTRO do Provider (o fallback é
            React puro, mas assim qualquer erro da árvore de rotas é contido) e
            FORA do ToastContainer, para o toast sobreviver ao fallback. */}
        <ErrorBoundary>
          <BrowserRouter>
            <GlobalStyles />
            <ModuleProvider>
              <AppContent />
            </ModuleProvider>
          </BrowserRouter>
        </ErrorBoundary>

        <ToastContainer
          position="top-center"
          transition={Slide}
          autoClose={3000}
          className="toast-container"
          style={{ zIndex: 99999 }}
        />
      </PersistGate>
    </Provider>
  );
}

export default App;
